<template>
  <div class="home-swip-item-box">
    <VueSlickCarousel v-bind="slideOptions" v-if="safeData && safeData.length > 0">
      <div v-for="(item,index) in safeData" :key="index" class="home-swip-item" @click='toBB(item)'>
        <span>{{ item.title }}</span>
        <p :class="item.change.indexOf('+') != -1 ? 'data-up':'data-down'">{{ parseFloat(item.close) }}</p>
        <span :class="item.change.indexOf('+') != -1 ? 'data-up':'data-down'">{{ item.change }}%</span>
        <p class="vol">Vol {{  (parseFloat(item.vol) / 1000).toFixed(2) }} K</p>
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "HomeSwipeItem",
  props: ['datalst'],
  computed:{
    safeData(){
      return this.datalst || []
    }
  },
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      slideOptions: {
        dots: false,
        arrows:false,
        focusOnSelect: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay:true
      },
    };
  },
  methods:{
    toBB(item){
      this.$router.push(
        {
          name: "exchange",
          query: {
            currentSymbol: item.symbol,
            name:item.title,
          },
        },
        () => {}
      );
    }
  }
};
</script>

<style>
</style>
